'use client'

import React from 'react'

/** Длинный отзыв свернут до нескольких строк: решает сам читатель. */
const LONG = 520

/**
 * Отзыв — письмо в номер: моноширинный текст на подложке со вторым оттиском,
 * подпись от руки.
 */
export function RisoLetter({ about, author, text }: { about?: string | null; author: string; text: string }) {
  const long = text.length > LONG
  const [open, setOpen] = React.useState(false)

  return (
    <figure className="riso-letter">
      <figcaption className="riso-letter__head">
        <span>Письмо в номер</span>
        {about ? <span>{about}</span> : null}
      </figcaption>

      <blockquote className="riso-letter__text" style={long && !open ? { ...CLAMP } : undefined}>
        {text}
      </blockquote>

      {long && (
        <button className="riso-letter__more" onClick={() => setOpen((v) => !v)} type="button">
          {open ? 'Свернуть' : 'Читать целиком'}
        </button>
      )}

      <p className="riso-letter__sign">{author}</p>
    </figure>
  )
}

const CLAMP: React.CSSProperties = {
  display: '-webkit-box',
  WebkitLineClamp: 10,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
}
